import { render, staticRenderFns } from "./widget-list.vue?vue&type=template&id=7604c548&scoped=true&"
import script from "./widget-list.vue?vue&type=script&lang=js&"
export * from "./widget-list.vue?vue&type=script&lang=js&"
import style0 from "./widget-list.vue?vue&type=style&index=0&id=7604c548&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7604c548",
  null
  
)

export default component.exports